import React, { useCallback, useEffect, useState } from 'react'
import styles from './scss/segmentation.module.scss';
import ApexBarChart from '../../components/custom_components/apexChartsTypes/barChart';
import WorktualCarousel from '../../components/custom_components/worktualCarousel';
import df from '../../styles/assets/images/segmentscardbg_1.svg'
import { useSelector } from 'react-redux';
import { getSegementationBasedOnCustomer, getSegementationDistributionChart, getSegementationTargetExperience, segmentationNlpDatas } from '../../apiservice/aiPilot';
import Loaders from '../../components/loader/loader';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';
// import img1 from "../../styles/assets/images/segmentscardbg_1.svg";
// import img2 from "../../styles/assets/images/segmentscardbg_2.svg";
// import img3 from "../../styles/assets/images/segmentscardbg_3.svg";
// import img4 from "../../styles/assets/images/segmentscardbg_4.svg";
import { getLycaSegementationBasedOnCustomer, getLycaSegementationDistributionChart, getLycaSegementationTargetExperience, segmentationNlpLycaDatas } from '../../apiservice/aiLycaPilot';

const Segmentation = () => {
  interface SeriesData {
    name: string;
    data: number[];
  }
  const { moduledateFilter } = useSelector((store: any) => store.dashboardReducer)
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState<any>([])
  const [segmentdata, setSegmentData] = useState<any>([])
  const [seriesSegment, setSeriesSegment] = useState<SeriesData[]>([]);
  const [categoriessegment, setCategoriesSegment] = useState<string[]>([]);
  const dispatch = useDispatcher()
  const [nlpData, setNlpData] = useState<any>(null);
  const { segmentationNlpData } = useSelector((store: any) => store.dashboardReducer)
  // const images = [img1, img2, img3 ,img4];
  useEffect(() => {
    const fetchNlpData = async () => {
      try {
        setLoader(true);

        const res = await segmentationNlpLycaDatas();
        if (res?.status === 200) {
          setNlpData(res.data.message); // store API result
          dispatch(dashboardAction.setSegmentationNlpData(res.data.message))
        }
      } catch (error) {
        console.error("Error fetching NLP data:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchNlpData();
  }, [dispatch]);

  useEffect(() => {
    callApis(moduledateFilter)
  }, [moduledateFilter])

  const callApis = (moduledateFilter: any) => {

    if (!moduledateFilter?.fromYear || !moduledateFilter?.toYear) return
    const body = {
      domainId: null,
      fromYear: moduledateFilter?.fromYear ?? null,
      toYear: moduledateFilter?.toYear ?? null,
    }
    getLycaSegementationTargetData(body)
    getLycaSegementationBasedOnCustomerdata(body)
    getLycaSegementationDistributionChartData(body)
  }

  const getLycaSegementationTargetData = async (body: any) => {
    try {
      setLoader(true);

      const res = await getLycaSegementationTargetExperience(body);
      if (res?.data?.statusCode === 200) {
        const data = res.data.response;
        setData(data)
      }
    } catch (error) {
      console.error("Error fetching segmentation target data:", error);
    } finally {
      setLoader(false);
    }
  };

  const getLycaSegementationBasedOnCustomerdata = async (body: any) => {
    try {
      setLoader(true);

      const res = await getLycaSegementationBasedOnCustomer(body);
      if (res?.data?.statusCode === 200) {
        const data = res.data.response;
        setSegmentData(data)
      }
    } catch (error) {
      console.error("Error fetching segmentation target data:", error);
    } finally {
      setLoader(false);
    }
  };


  const getLycaSegementationDistributionChartData = async (body: any) => {
    try {
      const res = await getLycaSegementationDistributionChart(body);

      if (res?.data?.statusCode === 200) {
        const data = res.data.response;
        // ✅ Segment mapping
        const segmentLabels: Record<number, string> = {
          0: "Data-centric low-spend prepaid",
          1: "Minimal-activity low-value prepaid",
          2: "Mid-tier mixed-usage customers",
          3: "Heavy data-voice power users",
          4: "High-balance low-usage bundle customers",
          5: "Premium heavy-usage customers",
          6: "High-spend instalment-paying premium customers",
        };

        // ✅ Replace Segment numbers with descriptive labels
        const categories = data.map(
          (item: any) => segmentLabels[item.Segments] || ` ${item.Segments}`
        );
        const chartData = data.map((item: any) => item.TotalRevenue || 0);
        // Set chart series
        setSeriesSegment([
          {
            name: "Total Revenue",
            data: chartData,
          },
        ]);

        // Set chart categories
        setCategoriesSegment(categories);
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  // Map API data to display-friendly format in High → Medium → Low order
  const order = ["General", "Churn Risk", "Low Value", "Upsell Target", "High CLV", "Medium CLV"];

  // Transform API data into carousel display items
  // const carouselItems = order
  //   .map((category) => {
  //     const data = segmentdata.find((item: any) => item.Category === category);
  //     if (!data) return null; // Skip if category not found in API response
  //     console.log('data--------', data)
  //     // Decide heading description based on category
  //     let headingDesc = "";
  //     switch (category) {
  //       case "High CLV":
  //         headingDesc = "Your most profitable segment; nurture them with premium experiences.";
  //         break;
  //       case "Medium CLV":
  //         headingDesc = "Growing contributors; engage to boost their potential.";
  //         break;
  //       case "Low Value":
  //         headingDesc = segmentationNlpData?.lowvalue_description || "Low activity segment; re-engage with targeted offers.";
  //         break;
  //       case "General":
  //         headingDesc = segmentationNlpData?.general_description || "Broad customer base; maintain engagement with regular updates.";
  //         break;
  //       case "Churn Risk":
  //         headingDesc = segmentationNlpData?.churnrisk_description || "At risk of leaving; win them back with targeted retention offers.";
  //         break;
  //       case "Upsell Target":
  //         headingDesc = segmentationNlpData?.upselltarget_description || "Prime candidates for upselling; offer complementary products.";
  //         break;
  //       default:
  //         headingDesc = "Segment information not available.";
  //     }

  //     return {
  //       count: data.totalCustomer.toLocaleString(),
  //       countTitle: "Customers",
  //       heading: category,
  //       headingDesc,
  //       avgRevenueCount: data.averageRevenue.toLocaleString(undefined, {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2
  //       }),
  //       clvCount: data.CLV.toLocaleString(undefined, {
  //         minimumFractionDigits: 0,
  //         maximumFractionDigits: 0
  //       })
  //     };
  //   })

  const clusterDescriptions: Record<number, string> = {
    0: "Heavy data usage but almost no voice, low balance, and small top-ups – typical “smartphone-only” prepaid behavior",
    1: "Extremely light users with almost no spend or engagement",
    2: "Balanced data + voice usage and some installment behavior; mid-spend segment",
    3: "Consume large amounts of both data and voice; maintain healthy balances; willing to pay for premium usage",
    4: "Keep large prepaid balances, under-utilize bundles, buy more than they use – strong “roll-over” candidates",
    5: "Similar to Heavy data-voice power users but with higher bundle spend and balances – premium subscribers",
    6: "High spenders with instalments, likely family or business plans; prefer smoothing payments"
  };

  const clusterHeading: Record<number, string> = {
    0: "DataLite ",
    1: "IdleSaver",
    2: "EverydayFlex ",
    3: "MaxStream ",
    4: "BundleBank ",
    5: "EliteEdge ",
    6: "PrimePay "
  };

  const carouselItems = segmentdata.map((item: any) => {
    return {
      count: item.TotalCustomers.toLocaleString(),
      countTitle: "Customers",
      heading: `${clusterHeading[item.Cluster] || "Segment information not available"}`,
      headingDesc: clusterDescriptions[item.Cluster] || "Segment information not available.",
      avgRevenueCount: `${Number(item.avgerage_revenue).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} Kr`,
      clvCount: `${Number(item.avgerage_revenue).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })} Kr`
    };
  });





  const slides = [
    <div>Slide 1</div>,
    <div>Slide 2</div>,
    <div>Slide 3</div>,
    <div>Slide 4</div>,
    <div>Slide 5</div>,
  ];


  const seriesbar = [{
    data: [44, 55, 41, 67, 22]
  }]

  const blocks = [
    {
      count: data[0]?.Customers ?? 0,
      title: "Active Customers",
      desc: "Active customers interacting across multiple touchpoints.",
    },
    {
      count: data[0]?.Segment ?? 0,
      title: "Segments",
      desc: "Customer groups based on shared traits, behavior, or value.",
    },
    {
      count: data[0]?.inactiveCustomers ?? 0,
      title: "Inactive Customers",
      desc: "Previously active customers who’ve stopped interacting or transacting recently.",
    },
    {
      count: data[0]?.Complaints ?? 0,
      title: "Complaints",
      desc: "Reported customer issues that may impact satisfaction and retention.",
    },
  ];


  return (
    <div className={styles.segmentationsec}>
      <p className={styles.paratxt}>Customers by shared traits to deliver <br /> targeted experiences.</p>
      <div className={styles.allotmentsecsegt}>
        {blocks.map((block, index) => (
          <div key={index} className={styles.altblocksegt}>
            <div className={styles.altcount}>{block.count}</div>
            <div className={styles.altinfos}>
              <h4>{block.title}</h4>
              <p>{block.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.cardssecsegt}>
        <div className={styles.titlearea}>
          <h4 className={styles.cdsheadertxt}>Segments</h4>
          <p className={styles.cdsdesc}>Segment customers to personalize interactions and drive results</p>
        </div>
        {/* <WorktualCarousel slides={slides} slidesPerView={2} /> */}
        <div className={styles.cardsec}>
          {loader ? (
            <Loaders />
          ) : (
            carouselItems.map((item: any, index: number) => {
              return (
                <div className={styles.cardwrapper} key={index}>
                  <div className={styles.cdtop}
                  // style={{ backgroundImage: `url(${images[index]})` }}
                  >
                    <h4>{item?.count ?? 0}</h4>
                    <p>{item?.countTitle ?? "-"}</p>
                  </div>
                  <div className={styles.cddatas}>
                    <div className={styles.cdtitledesc}>
                      <h4>{item?.heading ?? "-"}</h4>
                      <p>{item?.headingDesc ?? "-"}</p>
                    </div>
                    <div className={styles.cdresults}>
                      <div className={styles.cdresblock}>
                        <h4>Avg Revenue</h4>
                        <p>{item?.avgRevenueCount ?? 0}</p>
                      </div>
                      <div className={styles.cdresblock}>
                        <h4>CLV</h4>
                        <p>{item?.clvCount ?? 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div className={styles.chartandsummary}>
        <div className={`${styles.clvchartwrapper}`}>
          <div className={styles.clvwrapheader}>
            <div className={styles.clvwrapheadertxt}>Segment Distribution Chart</div>
            <div className={styles.clvwrpadesc}>Track the revenue for top-ups and Bundle from the segments</div>
          </div>
          <div className={styles.clvwrapbody}>
            <p className={styles.clvwrapcaptions}>x-axis <span> customer segment </span>y-axis <span>Total revenue</span></p>
            <ApexBarChart
              isStacked={false}
              series={seriesSegment}
              colors={["#575CFF"]}
              categories={categoriessegment}
              toastSuffix='Kr'
            />

          </div>
          {/* <div className={styles.clvwrapfooter}>
            <button className='insightsbtn'>AI Insights</button>
            <p className={styles.clvwrapfttxt}>Schedule system maintenance during low-activity hours and push notifications during peak hours to increase engagement.</p>
          </div> */}
        </div>
        <div className={styles.aisummarysec}>
          <div className={styles.aisummarywrapsec}>
            <div className={styles.aisumheading}>AI Summary</div>
            {/* <div className={styles.valuecus}>
              <h4 className={styles.aisumheading}>High-Value Customers</h4>
              <p className={styles.aisumdesc}>Trend: 📈 ARPU increasing by 12% QoQ.</p>
            </div>
            <div className={styles.valuecus}>
              <h4 className={styles.aisumheading}>Medium-Value Customers</h4>
              <p className={styles.aisumdesc}>Trend: ➖ Stable usage but low campaign engagement</p>
            </div>
            <div className={styles.valuecus}>
              <h4 className={styles.aisumheading}>Low-Value / Dormant Customers</h4>
              <p className={styles.aisumdesc}>Trend: 📈 ARPU increasing by 12% QoQ.</p>
            </div> */}
            {
              segmentationNlpData && (
                <div
                  className={styles.aisummarytxt}
                  dangerouslySetInnerHTML={{
                    __html: segmentationNlpData
                  }}
                />
              )
            }
          </div>
        </div>
      </div>
    </div>
  )
}


export default Segmentation